import Color from 'color';

import {
  DEFAULT_SETTINGS_COLORS,
  ISettingsColors,
} from '@wix/podcasts-common/dist/settings';
import { IStyleParamsColor } from '@wix/podcasts-common/dist/style-params';
import { IThemeColors } from '../../types';

function applyOpacity(color: string, opacity: number): string {
  return Color(color).alpha(opacity).rgb().string();
}

function colorsByTheme(
  defaultColors: { [key: string]: IStyleParamsColor },
  themeColors: IThemeColors,
): Record<string, string> {
  const colors = {};

  Object.keys(defaultColors).forEach((key) => {
    const themeColorName = defaultColors[key].color.themeName;
    const themeColor = themeColors.find(
      (_themeColor) => themeColorName === _themeColor.name,
    );

    if (!themeColor) {
      console.warn(`theme color is not found for default color:`, {
        [key]: defaultColors[key],
      });
      return;
    }

    colors[key] = applyOpacity(themeColor.value, defaultColors[key].opacity);
  });

  return colors;
}

function getSettingsColorsByTheme(themeColors: IThemeColors): ISettingsColors {
  return {
    main: colorsByTheme(DEFAULT_SETTINGS_COLORS.main, themeColors),
    episode: colorsByTheme(DEFAULT_SETTINGS_COLORS.episode, themeColors),
    common: colorsByTheme(DEFAULT_SETTINGS_COLORS.common, themeColors),
  };
}

export default getSettingsColorsByTheme;
